export class FetchIncidentTypes {
  public static readonly type = '[IncidentTypes] Fetch incidentTypes';
}
